import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Database } from '../providers/database';
import * as firebase from 'firebase';

@Injectable()

export class SpeakerData {
  listenerController: any;

  constructor(public af: AngularFire, public auth: AuthData, public db: Database) {
  }

  getSingleData(client: any, tokenSpeak: string) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Speakers/'+ tokenSpeak)
    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  getLikes(client: any, tokenSpeaker: string) {
    return this.af.database.object('/Clients/' + client.url + '/Speakers/' + tokenSpeaker + '/numLikes');
  }

  getFavorites(client: any) {
    return this.af.database.list('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Speaker');
  }

  getResourceFavorites(client: any) {
    return this.af.database.list('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Resource');
  }

  getMyLike(client: any, tokenSpeaker: string) {
    const q = firebase.database().ref().child('/Clients/' + client.url + '/___likesSpeaker/' + tokenSpeaker + '/' + this.auth.getUser().uid);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  pushFavorite(client, speakerData) {
    let obj = {
      summary: speakerData.summary,
      name: speakerData.name,
      hidePhoto: speakerData.hidePhoto,
      photo: speakerData.photo,
      position: speakerData.position,
      id: speakerData.id,
      timestamp: new Date().getTime()
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Speaker', obj, speakerData.id)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + speakerData.id + '/numFavorites').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushResourceFavorite(client, speakerId, resourceData) {
    let obj = {
      speakerId: speakerId,
      name: resourceData.name,
      nameFile: resourceData.nameFile,
      url: resourceData.url,
      id: resourceData.id,
      timestamp: new Date().getTime()
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Resource', obj, resourceData.id)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + speakerId + '/Resources/' + resourceData.id + '/numFavorites').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  getResources(client: any, speakerId: string) {
    return this.af.database.list('/Clients/' + client.url + '/Speakers/' + speakerId + '/Resources');
  }

  getResourcesActivity(client: any, event: any) {
    return this.af.database.list('/Clients/' + client.url + '/Events/' + event.id + '/Activity/resources');
  }

  getSpeaker(client: any, speakerId: string) {
    return this.af.database.object('/Clients/' + client.url + '/Speakers/' + speakerId);
  }

  getResourceMyLike(client: any, speakerId: string, resourceId: string) {
    const q = firebase.database().ref().child('/Clients/' + client.url + '/___likesResources/' + speakerId + '/' + resourceId + '/' + this.auth.getUser().uid);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  pushLikeResource(client: any, speakerId, resourceId) {
    let obj = {
      uid: this.auth.getUser().uid,
      resourceId: resourceId,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___likesResources/' + speakerId + '/' + resourceId, obj, this.auth.getUser().uid)
      .then(() => {
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + speakerId + '/Resources/' + resourceId + '/numLikes').transaction((currentCount) => {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  getComments(client: any, tokenEvent: string, tokenSpeaker: string) {
    return this.af.database.list('/Clients/' + client.url + '/___commentsSpeaker/' + tokenEvent + '/' + tokenSpeaker);
  }

  getResourceComments(client: any, speakerId: string, resourceId: string) {
    return this.af.database.list('/Clients/' + client.url + '/___commentsResources/' + speakerId + '/' + resourceId);
  }

  getCommentsActivity(client: any, activityId: string) {
    return this.af.database.list('/Clients/' + client.url + '/___commentsActivity/' + activityId);
  }

  pushLike(client:any, tokenSpeaker) {
    let obj = {
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___likesSpeaker/' + tokenSpeaker, obj, this.auth.getUser().uid)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + tokenSpeaker + '/numLikes').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushResourceComment(client: any, speakerId, resourceId, comment) {
    let obj = {
      comment: comment,
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___commentsResources/' + speakerId + '/' + resourceId, obj)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + speakerId + '/Resources/' + resourceId + '/numComments').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushResourceActivityComment(client: any, eventId, resourceId, comment) {
    let obj = {
      comment: comment,
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___commentsActivity/' + eventId + '/' + resourceId, obj)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Events/' + eventId + '/Activity/resources/' + resourceId + '/numComments').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushComment(client: any, tokenEvent, tokenSpeaker, comment) {
    let obj = {
      comment: comment,
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___commentsSpeaker/' + tokenEvent + '/' + tokenSpeaker, obj)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + tokenSpeaker + '/numComments').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/speaker.ts